import { TokenStorage } from "./../../../../core/auth/_services/token-storage.service";
// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
// RxJS
import { Observable, Subject, merge } from "rxjs";
import { finalize, takeUntil, tap } from "rxjs/operators";
// Translate
import { TranslateService } from "@ngx-translate/core";
// Store
import { Store } from "@ngrx/store";
import { AppState } from "../../../../core/reducers";
// Auth
import { AuthService } from "../../../../core/auth/_services/auth.service";
import { AuthNoticeService, Login } from "../../../../core/auth";
import { LayoutConfigService } from "../../../../core/_base/layout";
import { environment } from "environments/environment";
import { LayoutUtilsService, MessageType } from "app/core/_base/crud/utils/layout-utils.service";

/**
 * ! Just example => Should be removed in development
 */
const DEMO_PARAMS = {
	EMAIL: "",
	PASSWORD: "",
};

import { BroadcastService, MsalService } from "@azure/msal-angular";

@Component({
	selector: "kt-login",
	templateUrl: "./login.component.html",
	encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit, OnDestroy {
	// Public params
	loginForm: FormGroup;
	loading = false;
	isLoggedIn$: Observable<boolean>;
	errors: any = [];
	type = 1;
	UrlForgot = "";
	UrlRegister = "";

	isEnabledError = false;
	isMessageError = "";
	isClickSubmit = false;
	isMessagesubmit = "";
	private unsubscribe: Subject<any>;

	private redirectUrl: any;

	// Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	/**
	 * Component constructor
	 *
	 * @param router: Router
	 * @param auth: AuthService
	 * @param authNoticeService: AuthNoticeService
	 * @param translate: TranslateService
	 * @param store: Store<AppState>
	 * @param fb: FormBuilder
	 * @param cdr
	 * @param route
	 */
	constructor(
		private activatedRoute: ActivatedRoute,
		private router: Router, 
		private auth: AuthService, 
		private authNoticeService: AuthNoticeService, 
		private translate: TranslateService, 
		private store: Store<AppState>, 
		private fb: FormBuilder, 
		private cdr: ChangeDetectorRef, 
		private layoutConfigService: LayoutConfigService, 
		private route: ActivatedRoute, 
		private tokenStore: TokenStorage, 
		private layoutUtilsService: LayoutUtilsService, 
		private broadcastService: BroadcastService, 
		private authService: MsalService
	) {
		this.unsubscribe = new Subject();
	}

	ngOnInit(): void {
		this.initLoginForm();
		this.type = this.layoutConfigService.getTypeLoginForm();

		this.route.queryParams.subscribe((params) => {
			this.redirectUrl = params["redirectUrl"] || "/";
		});
		this.UrlForgot = "/auth/forgot-password";
		this.UrlRegister = "/auth/register";

		this.broadcastService.subscribe("msal:loginSuccess", () => {
			let account = this.authService.getAccount();
			if (account) {
				this.route.queryParams.subscribe((params) => {
					let str, redirectUrl: string;
					str = params["redirectUrl"];
					this.auth.microsoftAuthen(account.userName).subscribe((response) => {
						if (typeof response !== "undefined" && response.status === 1) {
							var date = new Date(response.data.TimeServe);
							date.setDate(date.getDate() + 1);
							var time = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
							if (str != null) {
								if (environment.redirectUrl.includes(str)) {
									redirectUrl = str + "/?sso_token=" + response.data.Token;
									window.location.href = redirectUrl;
								} else {
									this.router.navigate([str]).then((navigated: boolean) => {
										if (navigated && response.data.notifyDeliveryPlan) {
											this.layoutUtilsService.remindDeliveryPlan("/lich-xuat-hang-ban/ngay/" + time);
										}
									});
								}
							} else
								this.router.navigate(["/"]).then((navigated: boolean) => {
									if (navigated && response.data.notifyDeliveryPlan) {
										this.layoutUtilsService.remindDeliveryPlan("/lich-xuat-hang-ban/ngay/" + time);
									}
								});
						} else {
							this.authService.logout();
							this.isEnabledError = true;
							this.isMessageError = response.message ? response.message : "Không thể kết nối đến máy chủ, vui lòng quay lại sau.";
						}
						this.loading = false;
						this.cdr.detectChanges();
					});
				});
			} else {
				this.authService.logout();
				this.isMessageError = "Không tìm thấy thông tin tài khoản";
			}
		});
	}

	ngOnDestroy(): void {
		this.authNoticeService.setNotice(null);
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

	initLoginForm() {
		// demo message to show
		if (!this.authNoticeService.onNoticeChanged$.getValue()) {
			const initialNotice = `Use account
			<strong>${DEMO_PARAMS.EMAIL}</strong> and password
			<strong>${DEMO_PARAMS.PASSWORD}</strong> to continue.`;
			this.authNoticeService.setNotice(initialNotice, "info");
		}

		this.loginForm = this.fb.group({
			email: [
				DEMO_PARAMS.EMAIL,
				Validators.compose([
					Validators.required,
					Validators.maxLength(320), // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
				]),
			],
			password: [DEMO_PARAMS.PASSWORD, Validators.compose([Validators.required, Validators.maxLength(100)])],
			remember: {},
		});
	}

	submit() {
		const controls = this.loginForm.controls;

		/** check form */
		if (this.loginForm.invalid) {
			Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
			this.isClickSubmit = true;
			this.isMessagesubmit = this.showMessageSubmit();
			return;
		}

		this.loading = true;

		const authData = {
			username: controls["email"].value,
			password: controls["password"].value,
		};

		this.route.queryParams.subscribe((params) => {
			let str, redirectUrl: string;
			str = params["redirectUrl"];
			this.auth.login(authData.username, authData.password, str).subscribe((response) => {
				if (typeof response !== "undefined" && response.status === 1) {
					var date = new Date(response.data.TimeServe);
					date.setDate(date.getDate() + 1);
					var time = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
					if (str != null) {
						if (environment.redirectUrl.includes(str)) {
							redirectUrl = str + "/?sso_token=" + response.data.Token;
							window.location.href = redirectUrl;
							//this.layoutUtilsService.openSnackBar();
						} else {
							this.router.navigate([str]).then((navigated: boolean) => {
								if (navigated && response.data.notifyDeliveryPlan) {
									this.layoutUtilsService.remindDeliveryPlan("/lich-xuat-hang-ban/ngay/" + time);
								}
							});
						}
					} else
						this.router.navigate(["/"]).then((navigated: boolean) => {
							if (navigated && response.data.notifyDeliveryPlan) {
								this.layoutUtilsService.remindDeliveryPlan("/lich-xuat-hang-ban/ngay/" + time);
							}
						});
				} else {
					this.isEnabledError = true;
					this.isMessageError = response.message ? response.message : "Không thể kết nối đến máy chủ, vui lòng quay lại sau.";
				}
				this.loading = false;
				this.cdr.detectChanges();
			});
		});
	}

	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.loginForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}

	onAlertClose($event) {
		this.isEnabledError = false;
	}

	onAlertInputClose($event) {
		this.isClickSubmit = false;
	}

	showMessageSubmit() {
		let message = "";
		if (this.loginForm.controls["email"].value.toString().length == 0) {
			message += "tên đăng nhập";
		}
		if (this.loginForm.controls["password"].value.toString().length == 0) {
			if (message) message += ", ";
			message += "mật khẩu";
		}

		return message;
	}

	loginMicrosoft() {
		const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
		if (isIE) {
			this.authService.loginRedirect();
		} else {
			this.authService.loginPopup();
		}
	}
}
